
import qs from 'querystring'
import {
  AUTH_PROVIDER_STATUS_ERROR,
  AUTH_PROVIDER_STATUS_OK,
  AUTH_PROVIDER_STATUS_NO_USER,
  AUTH_PROVIDER_STATUS_CONFIRMATION_REQUIRED,
  AUTH_METHOD_PASSWORDLESS,
  AUTH_METHOD_PROCOUNTOR,
  AUTH_METHOD_PASSWORD,
  PARTNER_TYPE_FINAGO,
} from '~/utils/constants'
import { capitalize } from '~/utils/string'
import { VARIANT_BLUE } from '~/utils/UI'

export default {
  middleware: ['return'],
  data () {
    const queryParams = provider => qs.stringify({ return: `${window.location.origin}/login?provider=${provider}` })
    return {
      GOOGLE_LOGIN_URL: `${process.env.INTERNAL_API_URL}/auth/google?${queryParams('google')}`,
      MICROSOFT_LOGIN_URL: `${process.env.INTERNAL_API_URL}/auth/microsoft?${queryParams('microsoft')}`,
      PROCOUNTOR_LOGIN_URL: `${process.env.INTERNAL_API_URL}/auth/procountor?${queryParams('procountor')}`,
      email: null,
      useEmail: false,
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.loadingCount > 0
    },
    isFinago () {
      return this.partner && this.partner.attributes.type === PARTNER_TYPE_FINAGO
    },
    partner () {
      return this.$store.state.partner.partner
    },
  },
  async mounted () {
    const { provider, status, authorization_code: code } = this.$route.query
    if (provider && status === AUTH_PROVIDER_STATUS_OK) {
      try {
        this.$page.startLoading()
        const response = await this.$axios.$post('/auth/authorize', { code })
        await this.$store.dispatch('auth/login', response.token)
      } catch (e) {
        this.$log.error(e)
        this.$refs.wrapper.setAlert(this.$t('p.login.index.error-message', { provider: capitalize(provider) }))
      } finally {
        this.$page.stopLoading()
      }
    }

    if (provider && status) {
      this.setAuthProviderAlert(status)
    }
  },
  methods: {
    async handleEmailLogin () {
      if (!this.useEmail) {
        this.useEmail = true
        this.$nextTick(() => {
          this.$refs.emailInput?.focusInput()
        })
        return
      }

      if (!this.email || this.isLoading) {
        return
      }

      this.$refs.wrapper.clearAlert()
      this.$page.startLoading()
      this.$store.commit('auth/SET_AUTHENTICATION_EMAIL', this.email)

      try {
        const authMethods = await this.$axios.$get('/authMethods', {
          params: { type: 'client', email: this.email }
        })

        if (authMethods.includes(AUTH_METHOD_PASSWORD)) {
          this.$router.push('/login/password')
          return
        } else if (authMethods.includes(AUTH_METHOD_PROCOUNTOR)) {
          this.$router.push('/login/procountor')
          return
        } else if (authMethods.includes(AUTH_METHOD_PASSWORDLESS)) {
          const request = await this.$axios.$post('/v2/auth/login', { email: this.email })
          this.$router.push(`/login/passwordless?${qs.stringify({ loginRequest: request.data.id })}`)
        } else {
          this.$router.push('/login/password')
        }
      } catch (e) {
        this.$log.error(e)
        this.$refs.wrapper.setAlert(this.$t('common.error'))
      } finally {
        this.$page.stopLoading()
      }
    },
    setAuthProviderAlert (authProviderStatus) {
      const provider = this.$route.query.provider

      switch (authProviderStatus) {
        case AUTH_PROVIDER_STATUS_ERROR:
          this.$refs.wrapper.setAlert(this.$t('p.login.index.error-message', { provider: capitalize(provider) }))
          break
        case AUTH_PROVIDER_STATUS_NO_USER:
          this.$refs.wrapper.setAlert(this.$t('p.login.index.no-user-message', { provider: capitalize(provider) }))
          break
        case AUTH_PROVIDER_STATUS_CONFIRMATION_REQUIRED:
          this.$refs.wrapper.setAlert(
            this.$t('p.login.index.confirmation-required-message', { provider: capitalize(provider) }),
            VARIANT_BLUE
          )
          break
      }
    },
  }
}
